/**
 * Validate a model ID is a proper OpenRouter/provider format.
 * Valid: "openai/gpt-5.4", "google/gemini-2.5-flash", "anthropic/claude-sonnet-4"
 * Invalid: "gpt5.4", "gemini3.1", "claude" (no provider prefix slash)
 */
export function isValidModelId(modelId) {
  if (!modelId || typeof modelId !== 'string') return false;
  // Must contain a slash separating provider/model
  return modelId.includes('/') && modelId.split('/')[0].length > 0 && modelId.split('/')[1].length > 0;
}

/**
 * Check all voices in a list for invalid model IDs.
 * Returns array of voice indices with invalid models.
 */
export function getInvalidModelVoices(voices) {
  return voices
    .map((v, i) => ({ index: i, name: v.name, model: v.model || v.default_model, valid: isValidModelId(v.model || v.default_model) }))
    .filter(v => !v.valid);
}

/**
 * Get a human-readable error message for invalid models.
 */
export function getModelValidationMessage(invalidVoices) {
  if (invalidVoices.length === 0) return null;
  const names = invalidVoices.map(v => `"${v.name}" (${v.model})`).join(', ');
  return `${invalidVoices.length} voice${invalidVoices.length > 1 ? 's have' : ' has'} invalid model ID${invalidVoices.length > 1 ? 's' : ''}: ${names}. Model IDs must be in provider/model format (e.g., openai/gpt-5.4). Use the model picker dropdown to select a valid model.`;
}
